import React, { Component } from 'react'
import './event-list.scss'
import { Constants, ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import moment from 'moment'
import SessionCache from '../../routes/session-cache'
class EventList extends Component {
  state = {}
  data = []
  constructor (props) {
    super(props)
  }

  convertDate = (date, currentFormat = '', requiredFormat = 'DD MMM YYYY') => {
    return moment(date, currentFormat).format(requiredFormat)
  }

  getEventParticipated = event => {
    let user = SessionCache.getUser()

    if(user.schoolInfo?.eventParticipated?.length) {
      const idx = user.schoolInfo.eventParticipated.findIndex(e => {
        return e.eventId === event._id;
      })
      if(idx > -1) return true
      return false
    }
  }
  
  getEventProgress = event => {
    let eventEndDate = ''
    const today = moment()
    if (event.step3 && event.step3.endTime) {
      eventEndDate = moment(
        moment(event.step3.endTime, 'YYYY-MM-DDThh:mm:ssZ').format(
          'YYYY-MM-DD'
        ),
        'YYYY-MM-DD'
      ).add(1, 'days')
    }
    if (event.resultAnnounced) {
      return 'resultAnnounced'
    } else if (event.step3 && today.isSameOrAfter(eventEndDate)) {
      return 'final'
    } else {
      return 'baseline'
    }
  }

  render () {
    const {
      data,
      title,
      showPerformanceReport,
      showInviteStudents,
      showParticipateEvent,
      showInviteOption,
      showEventDetails
    } = this.props
    return (
      <div className='event-list'>
        <div className={`${title === "Active" ? "mt-1" : "mt-5"}`}>
          <div className='event-flag'>{title}</div>
          {data.map((item, index) => {
            const eventParticipated = this.getEventParticipated(item)
            return (
              <div
                key={index}
                className={`cw-plain-card cw-plain-card-wrapper mt-2 cw-event-${title.toLowerCase()}`}
              >
                <div className='row'>
                  <div className='col-8 event-details'>
                    <div>
                      <img
                        className='event-poster'
                        src={item.logo}
                      />
                    </div>
                    <div>
                      <div className='event-text cursor-pointer' onClick={_ => showEventDetails(item, title)}>{item.title}</div>
                      <div>
                        {item.description}
                          <span className='know-more cursor-pointer' onClick={_ => showEventDetails(item, title)}> KNOW MORE</span>
                      </div>
                      <div>
                        <span className='event-dates-title'>Dates: </span>
                        {this.convertDate(
                          item.eventStartDate,
                          'YYYY-MM-DDThh:mm:ssZ'
                        )}{item.step3  ? 
                          " - " + this.convertDate(item.step3.endTime,
                            'YYYY-MM-DDThh:mm:ssZ') : ""}
                      </div>
                    </div>
                  </div>

                  <div className='col-4 event-right'>
                    {eventParticipated && (
                      <button
                        className={`cw-btn-primary cw-btn-md ${title === "Upcoming" ? "cw-button-disabled": ""}`}
                        onClick={() => title !== "Upcoming" && showPerformanceReport(item)}
                      >
                        VIEW DETAILS
                      </button>
                    )}
                    {(title === "Active" || title === "Upcoming") && !eventParticipated && (
                      <button
                        className='cw-btn-primary cw-btn-md cw-btn-md2 mt-1'
                        onClick={() => showParticipateEvent(item)}
                      >
                        PARTICIPATE IN EVENT
                      </button>
                    )}
                    {(title === 'Upcoming' || title === 'Active') && 
                      this.getEventProgress(item) !== "resultAnnounced" && (
                      <button
                        className='cw-btn-primary cw-btn-md mt-1'
                        onClick={() => showInviteOption(item)}
                      >
                        INVITE STUDENTS
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default EventList
